import { createApp } from './main'

createApp({ language: document.documentElement.lang }).then(app =>
  app
    .getRouter()
    .isReady()
    .then(() => app.mount('#app'))
)
